/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * APIVersion defines the versioned schema of this representation of an object. Servers should convert recognized schemas to the latest internal value, and may reject unrecognized values. More info: https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#resources.
 */
export enum ApiVersion {
  ApiVersionV1beta1 = 'v1beta1',
  ApiVersionFlightctlIoV1beta1 = 'flightctl.io/v1beta1',
  ApiVersionEmpty = '',
}
